import {ACTION_CODE} from './_actionCode';
import {SubsidiaryService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'UPDATE_SUBSIDIARY_CATEGORY';

export async function updateSubsidiaryById(
    userData: Record<string, any>,
    subsidiaryId: number,
    payloadUpdate: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - updateSubsidiaryById - Start');

        const updateSubsidiaryByIdResult =
            await SubsidiaryService.updateSubsidiaryById(userData, subsidiaryId, payloadUpdate);

        LoggerService.logInfo('Action - updateSubsidiaryById - End - Success');

        return ResultModel.newSuccessResult(updateSubsidiaryByIdResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateSubsidiaryById - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur de mise à jour d\'une filiale',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
